import { render, staticRenderFns } from "./base-why-choose-legalnature-video.vue?vue&type=template&id=23520a6f&"
import script from "./base-why-choose-legalnature-video.vue?vue&type=script&lang=js&"
export * from "./base-why-choose-legalnature-video.vue?vue&type=script&lang=js&"
import style0 from "./base-why-choose-legalnature-video.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports